<template>
  <PageLayout
    class="support-page-card"
    :class="[pageClass, themeClass]"
    :title="title"
    :leftArrow="showBack"
    :clickLeft="handleBack"
    :showNavBar="false"
    :showLangChoose="false"
  >
    <div class="support-page-card__card">
      <div class="support-page-card__header">
        <div
          v-if="showBack"
          class="support-page-card__back"
          @click="handleBack"
        >
          <van-icon name="arrow-left" />
          <span>{{ resolvedBackText }}</span>
        </div>
        <LangChoose v-if="showLangChoose"></LangChoose>
        <h1 class="support-page-card__title">{{ title }}</h1>
        <p v-if="subtitle" class="support-page-card__subtitle">
          {{ subtitle }}
        </p>
        <slot name="header-extra"></slot>
      </div>
      <div v-if="$slots.toolbar" class="support-page-card__toolbar">
        <slot name="toolbar"></slot>
      </div>
      <div class="support-page-card__body">
        <slot></slot>
      </div>
      <div v-if="$slots.footer" class="support-page-card__footer">
        <slot name="footer"></slot>
      </div>
    </div>
    <slot name="overlay"></slot>
  </PageLayout>
</template>

<script>
import { mapState } from 'vuex';
import PageLayout from '@components/officialSupport/common/PageLayout.vue';
import LangChoose from '@components/officialSupport/LangChoose.vue';
import globalConfig from '@utiles/globalConfig';
import { getSupportThemeClass } from '@utiles/officialSupport/theme';

export default {
  name: 'SupportPageCard',
  components: {
    PageLayout,
    LangChoose
  },
  props: {
    /** 页面修饰 class，如 work-list / create-work */
    pageClass: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    showBack: {
      type: Boolean,
      default: true
    },
    /** 卡片 header 右上角语言选择（对齐 workhome） */
    showLangChoose: {
      type: Boolean,
      default: false
    },
    backText: {
      type: String,
      default: ''
    },
    /** 可选：覆盖 URL 中的 gameId（如创建工单切换游戏时换肤） */
    themeGameId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      urlParams: state => state.urlParams
    }),
    themeClass() {
      const gameId =
        this.themeGameId ||
        this.urlParams?.gameId ||
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id') ||
        '';
      return getSupportThemeClass(gameId);
    },
    resolvedBackText() {
      return this.backText || this.languages?.back || '';
    }
  },
  methods: {
    handleBack() {
      this.$emit('back');
    }
  }
};
</script>
